import { render } from "./TenantJobsView.vue?vue&type=template&id=2f4ee2a0&scoped=true"
import script from "./TenantJobsView.vue?vue&type=script&lang=js"
export * from "./TenantJobsView.vue?vue&type=script&lang=js"

import "./TenantJobsView.vue?vue&type=style&index=0&id=2f4ee2a0&scoped=true&lang=css"

import exportComponent from "/home/treim/code/applyhr/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4ee2a0"]])

export default __exports__